var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.slide)?_c('article',{staticClass:"additional-slide"},[_c('a',{attrs:{"href":_vm.slide.link,"target":"_blank"}},[(_vm.slide && _vm.slide.img)?_c('ImgComponent',{staticClass:"additional-slide__image",attrs:{"img":_vm.slide.img}}):_vm._e()],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }